export function removeDuplicatesById<T extends { id: number }>(valueList: T[]): T[] {
  return valueList.filter((thing, index, self) => index === self.findIndex((t) => t.id === thing.id));
}
